<div class="avail">
  @if (!storeService.getConditionalBalance()) {
    @let cnt = productService.countAvailability(product);

    @if (cnt > 0) {
      {{ productService.countAvailability(product).toLocaleString() }} <span class="unit">{{ unitHeader }}</span>
    } @else {
      -
    }

    <div [nbPopover]="wms" nbPopoverTrigger="hover" *ngIf="showDetails">
      <nb-icon icon="alert-circle-outline"/>
    </div>

  } @else {
    <div class="table-basket-num" [ngClass]="productService.classAvailability(product)">
      <span></span>
    </div>
  }
</div>

<ng-template #wms>
  <div [nbSpinner]="loading" class="wms-modal popup">
    <h6>Всего {{ productService.countAvailability(product).toLocaleString() }} <span class="unit">{{ unitHeader }}</span></h6>

    @let packs = packs$ | async;

    <ng-container *ngIf="packs">
      @if (packs?.isPack) {

        <div *ngFor="let pack of packs.productPacksList">
          <table class="ngx-table__table--tiny ngx-table" *ngIf="pack.productPacks?.length">
            <tr>
              <th i18n="@@Warehouse">Склад</th>
              <th i18n="@@Availabilities">Наличие</th>
            </tr>
            <tr>
              <td>{{ pack.header }}</td>
              <td>{{ pack.freeStock | number }} <span class="unit">{{ unitHeader }}</span></td>
            </tr>
            <tr>
              <th i18n="@@Packing">Тара, производитель</th>
              <th i18n="@@FreeOnStock">Свободно</th>
            </tr>
            <tr *ngFor="let item of pack.productPacks">
              <td>{{ item.header }}</td>
              <td>{{ item.stock | number }} <span class="unit">{{ unitHeader }}</span></td>
            </tr>
          </table>
        </div>

      } @else {

        <table class="ngx-table__table--tiny ngx-table" *ngIf="packs?.productRemain?.length">
          <tr>
            <th i18n="@@Warehouse">Склад</th>
            <th i18n="@@Availabilities">Наличие</th>
          </tr>
          <ng-container *ngFor="let pack of packs.productRemain">
            <tr *ngIf="pack.freeStock > 0">
              <td>{{ pack.header }}</td>
              <td>{{ pack.freeStock  | number }} <span class="unit">{{ unitHeader }}</span></td>
            </tr>
          </ng-container>
        </table>

      }

      <div>
        <ng-container *ngIf="packs?.suppleStock > 0">
          <div>Остатки у производителя - {{ packs.suppleStock | number }} <span class="unit">{{ unitHeader }}</span></div>
          <div *ngIf="packs.suppleTerm">Срок поставки - {{ packs.suppleTerm }} д.</div>
        </ng-container>

        <div *ngIf="multiplicityOrder > 1" i18n="@@MultiplicityOrder">Кратность заказа - <span> {{ multiplicityOrder }} <span class="unit">{{ unitHeader }}</span></span></div>
      </div>

    </ng-container>
  </div>

</ng-template>
